export const ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_REQUEST =
  'ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_REQUEST';
export const ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_SUCCESS =
  'ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_SUCCESS';
export const ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_FAILED =
  'ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_FAILED';
export const ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_CLEAR =
  'ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_CLEAR';

export const DELETE_DOMAIN_FROM_BLACKLIST_REQUEST =
  'DELETE_DOMAIN_FROM_BLACKLIST_REQUEST';
export const DELETE_DOMAIN_FROM_BLACKLIST_SUCCESS =
  'DELETE_DOMAIN_FROM_BLACKLIST_SUCCESS';
export const DELETE_DOMAIN_FROM_BLACKLIST_FAILED =
  'DELETE_DOMAIN_FROM_BLACKLIST_FAILED';
export const DELETE_DOMAIN_FROM_BLACKLIST_CLEAR =
  'DELETE_DOMAIN_FROM_BLACKLIST_CLEAR';

export const GET_IMAGES_TABLE_FIELDS_DATA_REQUEST =
  'GET_IMAGES_TABLE_FIELDS_DATA_REQUEST';
export const GET_IMAGES_TABLE_FIELDS_DATA_SUCCESS =
  'GET_IMAGES_TABLE_FIELDS_DATA_SUCCESS';
export const GET_IMAGES_TABLE_FIELDS_DATA_FAILED =
  'GET_IMAGES_TABLE_FIELDS_DATA_FAILED';
export const GET_IMAGES_TABLE_FIELDS_DATA_CLEAR =
  'GET_IMAGES_TABLE_FIELDS_DATA_CLEAR';

export const GET_DOMAIN_BY_NAME_REQUEST = 'GET_DOMAIN_BY_NAME_REQUEST';
export const GET_DOMAIN_BY_NAME_SUCCESS = 'GET_DOMAIN_BY_NAME_SUCCESS';
export const GET_DOMAIN_BY_NAME_FAILED = 'GET_DOMAIN_BY_NAME_FAILED';

export const GET_DOMAINS_BY_USAGE_URL_REQUEST =
  'GET_DOMAINS_BY_USAGE_URL_REQUEST';
export const GET_DOMAINS_BY_USAGE_URL_SUCCESS =
  'GET_DOMAINS_BY_USAGE_URL_SUCCESS';
export const GET_DOMAINS_BY_USAGE_URL_FAILED =
  'GET_DOMAINS_BY_USAGE_URL_FAILED';

export const GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_REQUEST =
  'GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_REQUEST';
export const GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_SUCCESS =
  'GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_SUCCESS';
export const GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_FAILED =
  'GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_FAILED';

export const GET_USAGE_URL_COUNT_REQUEST = 'GET_USAGE_URL_COUNT_REQUEST';
export const GET_USAGE_URL_COUNT_SUCCESS = 'GET_USAGE_URL_COUNT_SUCCESS';
export const GET_USAGE_URL_COUNT_FAILED = 'GET_USAGE_URL_COUNT_FAILED';

export const GET_BLACKLISTED_DOMAIN_BY_NAME_REQUEST =
  'GET_BLACKLISTED_DOMAIN_BY_NAME_REQUEST';
export const GET_BLACKLISTED_DOMAIN_BY_NAME_SUCCESS =
  'GET_BLACKLISTED_DOMAIN_BY_NAME_SUCCESS';
export const GET_BLACKLISTED_DOMAIN_BY_NAME_FAILED =
  'GET_BLACKLISTED_DOMAIN_BY_NAME_FAILED';

export const GET_IMAGES_BY_AGENCY_AND_ID_REQUEST =
  'GET_IMAGES_BY_AGENCY_AND_ID_REQUEST';
export const GET_IMAGES_BY_AGENCY_AND_ID_SUCCESS =
  'GET_IMAGES_BY_AGENCY_AND_ID_SUCCESS';
export const GET_IMAGES_BY_AGENCY_AND_ID_FAILED =
  'GET_IMAGES_BY_AGENCY_AND_ID_FAILED';

export const GET_DOMAIN_FLOW_STATUSES_REQUEST =
  'GET_DOMAIN_FLOW_STATUSES_REQUEST';
export const GET_DOMAIN_FLOW_STATUSES_SUCCESS =
  'GET_DOMAIN_FLOW_STATUSES_SUCCESS';
export const GET_DOMAIN_FLOW_STATUSES_FAILED =
  'GET_DOMAIN_FLOW_STATUSES_FAILED';

export const GET_COUNTRIES_LIST_REQUEST = 'GET_COUNTRIES_LIST_REQUEST';
export const GET_COUNTRIES_LIST_SUCCESS = 'GET_COUNTRIES_LIST_SUCCESS';
export const GET_COUNTRIES_LIST_FAILED = 'GET_COUNTRIES_LIST_FAILED';

export const CHANGE_USAGE_IMAGES_DATA = 'CHANGE_USAGE_IMAGES_DATA';
export const CHANGE_CLICKHOUSE_USAGE_IMAGES_DATA =
  'CHANGE_CLICKHOUSE_USAGE_IMAGES_DATA';
